import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CompsPageComponent } from "./comps-page/comps-page.component";
import {
  Routes,
  RouterModule,
  CanDeactivateFn,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IconsModule } from "@va/core-library/icons";

import { CompsGridComponent } from "./comps-grid/comps-grid.component";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { SharedModule } from "../shared/shared.module";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { CompsTickerModalComponent } from "./comps-ticker-modal/comps-ticker-modal.component";
import { MatMenuModule } from "@angular/material/menu";
import { CompsGridFiltersComponent } from "./comps-grid-filters/comps-grid-filters.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { CreateNewCompsWizardComponent } from "./create-new-comps-wizard/create-new-comps-wizard.component";
import { CreateNewCompsBaseComponent } from "./create-new-comps-base/create-new-comps-base.component";
import { CreateCompsLIModalComponent } from "./create-comps-li-modal/create-comps-li-modal.component";
import { CompsYearTypeFilterComponent } from "./comps-year-type-filter/comps-year-type-filter.component";
import { CreateNewCompsNamingComponent } from "./create-new-comps-naming/create-new-comps-naming.component";
import { ShareCompsTableComponent } from "./share-comps-table/share-comps-table.component";
import { ConvertCompsModalComponent } from "./convert-comps-modal/convert-comps-modal.component";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzStepsModule } from "ng-zorro-antd/steps";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzMenuModule } from "ng-zorro-antd/menu";

const CanDeactivateGuard: CanDeactivateFn<CompsPageComponent> = (
  component: CompsPageComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot,
) => {
  if (component.hasUnsavedData) {
    component.promptToSave(nextState.url);
    return false;
  }
  return true;
};

const compsRoutes: Routes = [
  {
    path: ":tabType",
    component: CompsPageComponent,
    data: {
      title: "Comps Page",
    },
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ":tabType/:tabId",
    component: CompsPageComponent,
    data: {
      title: "Comps Page",
    },
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(compsRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class CompsRoutingModule {}

@NgModule({
  declarations: [
    CompsPageComponent,
    CompsGridComponent,
    CompsTickerModalComponent,
    CompsGridFiltersComponent,
    CreateNewCompsWizardComponent,
    CreateNewCompsBaseComponent,
    CreateCompsLIModalComponent,
    CompsYearTypeFilterComponent,
    CreateNewCompsNamingComponent,
    ShareCompsTableComponent,
    ConvertCompsModalComponent,
  ],
  bootstrap: [
    CompsTickerModalComponent,
    CreateNewCompsWizardComponent,
    ShareCompsTableComponent,
    ConvertCompsModalComponent,
  ],
  imports: [
    CommonModule,
    CompsRoutingModule,
    FormsModule,
    IconsModule,

    MatTableModule,
    MatButtonModule,
    SharedModule,
    MatSortModule,
    MatMenuModule,
    MatSelectModule,
    ChartPlotterModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    PeriodFilterModule,
    CurrencySelectModule,
    NzPopoverModule,
    NzSkeletonModule,
    NzCheckboxModule,
    NzRadioModule,
    NzDatePickerModule,
    NzSelectModule,
    NzSpinModule,
    NzModalModule,
    NzDropDownModule,
    NzStepsModule,
    NzInputModule,
    NzAutocompleteModule,
    NzTableModule,
    NzIconModule,
    NzToolTipModule,
    NzPopoverModule,
    NzGridModule,
    NzSpinModule,
    NzMenuModule,
  ],
  exports: [CompsGridComponent, CompsTickerModalComponent],
})
export class CompsPageModule {}
